export default function AnyOutlineIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM12 10.5858L13.4142 12L12 13.4142L10.5858 12L12 10.5858ZM12 7.75732L13.4142 9.17154L14.8284 10.5858L16.2426 12L14.8284 13.4142L13.4142 14.8284L12 16.2426L10.5858 14.8284L9.17157 13.4142L7.75736 12L9.17157 10.5858L10.5858 9.17154L12 7.75732Z"
        fill="var(--text-primary-color)"
      />
    </svg>
  );
}
